import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home-steps',
    templateUrl: './home-steps.component.html',
    styleUrls: ['./home-steps.component.scss'],
  })
export class HomeStepsComponent {
  constructor(private _router: Router) {}
}
